// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"624ea93f","155":"bf3e1953","332":"fab619bc","382":"738cba80","619":"f7f74021","661":"878c5d5a","812":"7b40abea","977":"5bca1eee"}[chunkId] + ".chunk.js";
};